export const BACK = 'MDC/STEPPER/BACK';
export const RESOLVE = 'MDC/STEPPER/RESOLVE';
export const REJECT = 'MDC/STEPPER/REJECT';
export const GO = 'MDC/STEPPER/GO';
export const INIT = 'MDC/STEPPER/INIT';
export const RESET = 'MDC/STEPPER/RESET';
export const CLEAN_ERROR = 'MDC/STEPPER/CLEAN_ERROR';

export const back = () => ({
  type: BACK,
});

export const resolve = data => ({
  type: RESOLVE,
  data,
});

export const reject = error => ({
  type: REJECT,
  error,
});

export const go = idx => ({
  type: GO,
  idx,
});

export const init = ({ current, steps }) => ({
  type: INIT,
  current,
  steps,
});

export const reset = () => ({
  type: RESET,
});

export const cleanError = () => ({
  type: CLEAN_ERROR,
});

export default {
  resolve,
  reject,
  back,
  go,
  init,
  reset,
  cleanError,
};
